import { Link } from "react-router-dom";
import { SiteHeader } from "../components/SiteHeader";

export function PrivacyPage() {
  return (
    <div className="legal-page">
      <SiteHeader quiet />
      <main className="legal-shell">
        <p className="section-label">Privacy notice · Booking Desk</p>
        <h1>Your meeting details stay focused on the meeting.</h1>
        <p className="legal-lede">
          RSM Consulting collects the name, email address, timezone, notes, and time you provide only to arrange and manage your appointment.
        </p>
        <section>
          <h2>What happens to your information</h2>
          <p>Your details are stored in RSM&rsquo;s private Supabase project and are visible only to authorised RSM members. A new booking also creates a private notification in the central meeting dashboard.</p>
          <p>RSM does not sell booking information or use it for unrelated marketing. Calendar links are generated from the appointment details you already see.</p>
        </section>
        <section>
          <h2>Retention and your choices</h2>
          <p>Meeting records are retained only for operational and reasonable record-keeping needs, then deleted or anonymised. Your private management link lets you reschedule or cancel without creating an account.</p>
          <p>To request access, correction, or deletion, email <a href="mailto:mathapershadshahil@gmail.com">mathapershadshahil@gmail.com</a>.</p>
        </section>
        <Link className="back-link" to="/">← Back to RSM</Link>
      </main>
    </div>
  );
}
